import * as XLSX from 'xlsx';

export type ExcelExportSheet = {
  name: string;
  rows: Array<Record<string, unknown>>;
};

const EXCEL_SHEET_NAME_MAX_LENGTH = 31;
const INVALID_SHEET_NAME_CHARS = /[\\/*?:[\]]/g;

export const sanitizeExcelSheetName = (value: string) => {
  const sanitized = value.replace(INVALID_SHEET_NAME_CHARS, ' ').trim();
  const truncated = sanitized.slice(0, EXCEL_SHEET_NAME_MAX_LENGTH).trim();
  return truncated || 'Foglio';
};

export const resolveUniqueExcelSheetNames = (sheets: ExcelExportSheet[]) => {
  const usedNames = new Map<string, number>();

  return sheets.map(sheet => {
    const baseName = sanitizeExcelSheetName(sheet.name);
    const count = usedNames.get(baseName) ?? 0;
    usedNames.set(baseName, count + 1);

    if (count === 0) {
      return baseName;
    }

    const suffix = ` (${count + 1})`;
    const maxBaseLength = EXCEL_SHEET_NAME_MAX_LENGTH - suffix.length;
    return `${baseName.slice(0, maxBaseLength).trim()}${suffix}`;
  });
};

export const buildExcelWorkbook = (sheets: ExcelExportSheet[]) => {
  const workbook = XLSX.utils.book_new();
  const sheetNames = resolveUniqueExcelSheetNames(sheets);

  sheets.forEach((sheet, index) => {
    if (sheet.rows.length === 0) return;

    const worksheet = XLSX.utils.json_to_sheet(sheet.rows);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetNames[index]);
  });

  return workbook;
};

export const downloadExcelWorkbook = (
  workbook: XLSX.WorkBook,
  filename: string
) => {
  XLSX.writeFile(workbook, filename);
};
